import React from 'react';
import iron_bars from '../../../../assets/images/Iron-bars.png';
import login_background from '../../../../assets/images/login_background.png';
import logo from '../../../../assets/icons/logo.png';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
// import { history } from '../../../../app/history.js';
import { history } from '../../../../app/history';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { Message } from 'semantic-ui-react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import LocalStorage from '../../../../utilities/localStorage.js';
import { login } from '../../redux/slice';

const LoginPage = () => {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const [errorMsg] = useState('');
  const dispatch = useDispatch();
  let location = useLocation();

  const handleOnClick = () => {
    instance
      .loginPopup({
        scopes: ['User.Read'],
        prompt: 'select_account',
      })
      .then((result) => {
        //console.log('result45: ',result);
        //localStorage.setItem("token", result.accessToken);
        return dispatch(login({ token: result.accessToken }));
      })

      .then((result) => {
        //console.log(result);
        if (result?.payload?.success) {
          LocalStorage.setItem('bbs_user', JSON.stringify(result?.payload));
          const user = result?.payload;
          //  console.log('user@@@@: ',user)

          if (user?.user?.Role?.role === 'REQUESTER') {
            location.state?.from?.pathname
              ? history.push(`${location.state?.from?.pathname}`)
              : history.push('/dashboard');
          } else if (user?.user?.Role?.role === 'MANAGER') {
            location.state?.from?.pathname
              ? history.push(`${location.state?.from?.pathname}`)
              : history.push('/dashboard');
          } else if (user?.user?.Role?.role === 'VIEWER') {
            location.state?.from?.pathname
              ? history.push(`${location.state?.from?.pathname}`)
              : history.push('/viewer/dashboard');
          }
        } else {
          console.log('$$$$$$$$$$$$$$$$$$$');
          console.log('result:', result);
        }
      })
      .catch((err) => {
        console.log('$$$$$$$$$$$$$$$$$$$', err, err);
        if (isAuthenticated) {
          instance.logoutRedirect({
            account: LocalStorage.homeAccountId,
            postLogoutRedirectUri: '/',
            mainWindowRedirectUri: '/',
          });
        }
      });
  };

  return (
    <div className="flex flex-col md:flex-row w-full overflow-hidden bg-gradient-to-b from-gradient-start to-gradient-end">
      {/* Left section */}
      <div className="hidden md:block md:w-1/2 h-screen">
        <img
          className="h-auto md:h-[700px] max-w-full"
          src={iron_bars}
          alt="Iron Bars"
        />
      </div>

      {/* Right section */}
      <div
        className="relative w-full md:w-1/2 bg-cover bg-center flex flex-col items-center justify-center h-screen overflow-hidden"
        style={{
          backgroundImage: `url(${login_background})`,
        }}
      >
        <div className="absolute top-8 left-4 md:right-4 md:left-auto md:top-4 md:mt-5 md:mr-3">
          <img
            src={logo}
            alt="Logo"
            className="h-[28px] w-[120px] md:h-[28px] md:w-[130px]"
          />
        </div>
        {/* Text and button */}
        <div className="flex flex-col items-center justify-center px-4 md:px-0 mt-20 md:mt-20 2xl:mt-[-100px]">
          <p className="font-sans font-bold text-[32px] md:text-[40px] leading-[38px] text-[#2364AD] text-center mb-5">
            BBS Optimization Tool
          </p>
          <p className="mt-6 md:mt-9 font-sans font-bold text-[24px] md:text-[30px] leading-[30px] text-[#2364AD] text-center">
            Welcome!
          </p>
          <p className="mt-2 text-[14px] md:text-[16px] leading-[20px] md:leading-[24px] text-[#667085] text-center">
            Login with your microsoft credentials
          </p>

          {/* Button */}
          <button
            onClick={handleOnClick}
            className="bg-[#2364AD] w-full md:w-[424px] pt-3 pb-3 px-4 md:pt-[10px] md:pb-[10px] 
                    border border-[#2364AD] rounded-lg text-white font-sans 
                    text-[14px] md:text-[16px] leading-[20px] md:leading-[24px] mt-4"
          >
            Go to your Account
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
